import { render, staticRenderFns } from "./ProvidersDetails.vue?vue&type=template&id=8880999a&scoped=true&"
import script from "./ProvidersDetails.vue?vue&type=script&lang=js&"
export * from "./ProvidersDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProvidersDetails.vue?vue&type=style&index=0&id=8880999a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8880999a",
  null
  
)

component.options.__file = "ProvidersDetails.vue"
export default component.exports